<template>
    <v-row >
        <v-col cols="12" md="6">
            <v-card>
                <v-card-title>
                    <b>New specialist</b>
                </v-card-title>
                <v-card-text class="text--primary">
                    <client-specialist-form ref="client-specialist-creation-form"
                                            @validation-changed="handleFormValidationChanged"/>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" :disabled="!createButtonActive" @click="handleCreateButtonClick"
                           :loading="progress('createClientSpecialist')">
                        Create
                    </v-btn>
                    <v-btn @click="handleCancelButtonClick">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import ClientSpecialistForm from '../Components/ClientSpecialistForm'

    export default {
        name: "CreateClientSpecialist",
        props: {
            client: Object
        },
        components: {
            ClientSpecialistForm,
        },
        data() {
            return {
                formValid: false
            }
        },
        mounted() {
            this.formValid = this.$refs['client-specialist-creation-form'].isFormValid()
        },
        computed: {
            ...mapGetters('clients', {
                progress: 'progress'
            }),
            createButtonActive() {
                return this.formValid && !this.progress('createClientSpecialist')
            }
        },
        methods: {
            ...mapActions({
                create: 'clients/createClientSpecialist'
            }),
            async handleCreateButtonClick() {
                const formData = this.$refs['client-specialist-creation-form'].getFormData()
                formData.clientId = this.client.id
                const creationResult = await this.create(formData)

                if (!creationResult) {
                    return
                }

                this.$refs['client-specialist-creation-form'].reset()
                this.$router.push({path: `/clients/${this.client.id}/specialists`})
            },
            handleCancelButtonClick() {
                this.$refs['client-specialist-creation-form'].reset()
                this.$router.push({path: `/clients/${this.client.id}/specialists`})
            },
            handleFormValidationChanged(value) {
                this.formValid = value
            }
        }
    }
</script>

<style scoped>

</style>